import {
    graphql
} from 'react-relay'


const query = graphql`
    query getAllPaymentModeQuery ($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllPaymentMode (pagination: $pagination, sorts: $sorts, where: $where) {
            count,
            items {
                id
                name
                createdAt
                updatedAt
            }
      }
    }
  `

  export default query;